import { createFileRoute, redirect, useNavigate, useSearch } from '@tanstack/react-router'
import { TeacherTestResultPage } from '@unsw/features/teacher-dashboard'
import { useSidebar } from '@unsw/hooks'
import { useIsMobile } from '@unsw/hooks'
import { getUserRole } from '@unsw/hooks'

type TeacherTestResultSearch = {
  requestId?: number
}

export const Route = createFileRoute('/dashboard/teacher-test-result')({
  beforeLoad: () => {
    const { isTeacher, isAdmin } = getUserRole()
    if (!isTeacher && !isAdmin) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: TeacherTestResultRoute,
  validateSearch: (search: Record<string, unknown>): TeacherTestResultSearch => {
    return {
      requestId: search.requestId ? Number(search.requestId) : undefined,
    }
  },
})

function TeacherTestResultRoute() {
  const navigate = useNavigate({ from: '/dashboard/teacher-test-result' })
  const { requestId } = useSearch({ from: '/dashboard/teacher-test-result' })
  const isMobile = useIsMobile()
  const { sidebarCollapsed, toggleSidebar, closeSidebar } = useSidebar()

  const handleSelectRequest = (id: number) => {
    navigate({
      search: { requestId: id },
    })
  }

  return (
    <TeacherTestResultPage
      isMobile={isMobile === true}
      sidebarCollapsed={sidebarCollapsed}
      onToggleSidebar={toggleSidebar}
      onCloseSidebar={closeSidebar}
      selectedRequestId={requestId}
      onSelectRequest={handleSelectRequest}
    />
  )
}
